import { createReducer } from 'redux-act';
import actions from '../actions/dropdownMasterActions';

const initialState = {
    getFilteredDropdownDataPending: false,
    getFilteredDropdownDataRes: null,
    getFilteredDropdownDataError: null,

    addDropdownDataPending: false,
    addDropdownDataRes: null,
    addDropdownDataError: null,

    getAllDropdownDataPending: false,
    getAllDropdownDataRes: null,
    getAllDropdownDataError: null,

    deleteDropdownDataPending: false,
    deleteDropdownDataRes: null,
    deleteDropdownDataError: null,

    updateDropdownDataPending: false,
    updateDropdownDataRes: null,
    updateDropdownDataError: null,

    getDropdownMasterConstantDataPending: false,
    getDropdownMasterConstantDataRes: null,
    getDropdownMasterConstantDataError: null,

    addMasterDropdownCategoryPending: false,
    addMasterDropdownCategoryRes: null,
    addMasterDropdownCategoryError: null,

    getMasterDropdownCategoryPending: false,
    getMasterDropdownCategoryRes: null,
    getMasterDropdownCategoryError: null,


    getAllMasterDropdownCategoryPending: false,
    getAllMasterDropdownCategoryRes: null,
    getAllMasterDropdownCategoryError: null,

    updateMasterDropdownCategoryPending: false,
    updateMasterDropdownCategoryRes: null,
    updateMasterDropdownCategoryError: null,

    deleteMasterDropdownCategoryPending: false,
    deleteMasterDropdownCategoryRes: null,
    deleteMasterDropdownCategoryError: null,

    createQuestionPending: false,
    createQuestionRes: null,
    createQuestionError: null,

    getQuestionPending: false,
    getQuestionRes: null,
    getQuestionError: null,

    getAllQuestionPending: false,
    getAllQuestionRes: null,
    getAllQuestionError: null,

    updateQuestionPending: false,
    updateQuestionRes: null,
    updateQuestionError: null,

    deleteQuestionPending: false,
    deleteQuestionRes: null,
    deleteQuestionError: null,

    addAnswerPending: false,
    addAnswerRes: null,
    addAnswerError: null,

        getDropDownMasterPending: false,
    getDropDownMasterRes: null,
    getDropDownMasterError: null,
};


/*  Get Filtered Dropdown Data Reducers */
const handleGetFilteredDropdownDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getFilteredDropdownDataPending: true,
            getFilteredDropdownDataRes: null,
            getFilteredDropdownDataError: null,
        },
    };
};
const handleGetFilteredDropdownDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getFilteredDropdownDataPending: false,
            getFilteredDropdownDataRes: payload,
            getFilteredDropdownDataError: null,
        },
    };
};
const handleGetFilteredDropdownDataError = (state1, payload) => ({
    ...state1,
    ...{
        getFilteredDropdownDataPending: false,
        getFilteredDropdownDataRes: null,
        getFilteredDropdownDataError: payload,
    },
});


/* Add Dropdown Data Reducers */
const handleAddDropdownDataRequest = state1 => {
    return {
        ...state1,
        ...{
            addDropdownDataPending: true,
            addDropdownDataRes: null,
            addDropdownDataError: null,
        },
    };
};
const handleAddDropdownDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            addDropdownDataPending: false,
            addDropdownDataRes: payload,
            addDropdownDataError: null,
        },
    };
};
const handleAddDropdownDataError = (state1, payload) => ({
    ...state1,
    ...{
        addDropdownDataPending: false,
        addDropdownDataRes: null,
        addDropdownDataError: payload,
    },
});

/* Get All Dropdown Data Reducers */
const handleGetAllDropdownDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllDropdownDataPending: true,
            getAllDropdownDataRes: null,
            getAllDropdownDataError: null,
        },
    };
};
const handleGetAllDropdownDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllDropdownDataPending: false,
            getAllDropdownDataRes: payload,
            getAllDropdownDataError: null,
        },
    };
};
const handleGetAllDropdownDataError = (state1, payload) => ({
    ...state1,
    ...{
        getAllDropdownDataPending: false,
        getAllDropdownDataRes: null,
        getAllDropdownDataError: payload,
    },
});

/* Delete Dropdown Data Reducers*/
const handleDeleteDropdownDataRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteDropdownDataPending: true,
            deleteDropdownDataRes: null,
            deleteDropdownDataError: null,
        },
    };
};
const handleDeleteDropdownDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteDropdownDataPending: false,
            deleteDropdownDataRes: payload,
            deleteDropdownDataError: null,
        },
    };
};
const handleDeleteDropdownDataError = (state1, payload) => ({
    ...state1,
    ...{
        deleteDropdownDataPending: false,
        deleteDropdownDataRes: null,
        deleteDropdownDataError: payload,
    },
});

/* Update Dropdown Data Reducers */
const handleUpdateDropdownDataRequest = state1 => {
    return {
        ...state1,
        ...{
            updateDropdownDataPending: true,
            updateDropdownDataRes: null,
            updateDropdownDataError: null,
        },
    };
};
const handleUpdateDropdownDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateDropdownDataPending: false,
            updateDropdownDataRes: payload,
            updateDropdownDataError: null,
        },
    };
};
const handleUpdateDropdownDataError = (state1, payload) => ({
    ...state1,
    ...{
        updateDropdownDataPending: false,
        updateDropdownDataRes: null,
        updateDropdownDataError: payload,
    },
});

/* Get Dropdown Master Constant Reducers*/
const handleGetDropdownMasterConstantDataRequest = state1 => {
    return {
        ...state1,
        ...{
            getDropdownMasterConstantDataPending: true,
            getDropdownMasterConstantDataRes: null,
            getDropdownMasterConstantDataError: null,
        },
    };
};
const handleGetDropdownMasterConstantDataSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getDropdownMasterConstantDataPending: false,
            getDropdownMasterConstantDataRes: payload,
            getDropdownMasterConstantDataError: null,
        },
    };
};
const handleGetDropdownMasterConstantDataError = (state1, payload) => ({
    ...state1,
    ...{
        getDropdownMasterConstantDataPending: false,
        getDropdownMasterConstantDataRes: null,
        getDropdownMasterConstantDataError: payload,
    },
});

const handleAddMasterDropdownCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            addMasterDropdownCategoryPending: true,
            addMasterDropdownCategoryRes: null,
            addMasterDropdownCategoryError: null,
        },
    };
};
const handleAddMasterDropdownCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            addMasterDropdownCategoryPending: false,
            addMasterDropdownCategoryRes: payload,
            addMasterDropdownCategoryError: null,
        },
    };
};
const handleAddMasterDropdownCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        addMasterDropdownCategoryPending: false,
        addMasterDropdownCategoryRes: null,
        addMasterDropdownCategoryError: payload,
    },
});

const handleGetMasterDropdownCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            getMasterDropdownCategoryPending: true,
            getMasterDropdownCategoryRes: null,
            getMasterDropdownCategoryError: null,
        },
    };
};
const handleGetMasterDropdownCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getMasterDropdownCategoryPending: false,
            getMasterDropdownCategoryRes: payload,
            getMasterDropdownCategoryError: null,
        },
    };
};
const handleGetMasterDropdownCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        getMasterDropdownCategoryPending: false,
        getMasterDropdownCategoryRes: null,
        getMasterDropdownCategoryError: payload,
    },
});

const handleGetAllMasterDropdownCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllMasterDropdownCategoryPending: true,
            getAllMasterDropdownCategoryRes: null,
            getAllMasterDropdownCategoryError: null,
        },
    };
};
const handleGetAllMasterDropdownCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllMasterDropdownCategoryPending: false,
            getAllMasterDropdownCategoryRes: payload,
            getAllMasterDropdownCategoryError: null,
        },
    };
};
const handleGetAllMasterDropdownCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        getAllMasterDropdownCategoryPending: false,
        getAllMasterDropdownCategoryRes: null,
        getAllMasterDropdownCategoryError: payload,
    },
});

const handleUpdateMasterDropdownCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            updateMasterDropdownCategoryPending: true,
            updateMasterDropdownCategoryRes: null,
            updateMasterDropdownCategoryError: null,
        },
    };
};
const handleUpdateMasterDropdownCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateMasterDropdownCategoryPending: false,
            updateMasterDropdownCategoryRes: payload,
            updateMasterDropdownCategoryError: null,
        },
    };
};
const handleUpdateMasterDropdownCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        updateMasterDropdownCategoryPending: false,
        updateMasterDropdownCategoryRes: null,
        updateMasterDropdownCategoryError: payload,
    },
});

const handleDeleteMasterDropdownCategoryRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteMasterDropdownCategoryPending: true,
            deleteMasterDropdownCategoryRes: null,
            deleteMasterDropdownCategoryError: null,
        },
    };
};
const handleDeleteMasterDropdownCategorySuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteMasterDropdownCategoryPending: false,
            deleteMasterDropdownCategoryRes: payload,
            deleteMasterDropdownCategoryError: null,
        },
    };
};
const handleDeleteMasterDropdownCategoryError = (state1, payload) => ({
    ...state1,
    ...{
        deleteMasterDropdownCategoryPending: false,
        deleteMasterDropdownCategoryRes: null,
        deleteMasterDropdownCategoryError: payload,
    },
});

/* Add Question Reducers */
const handleCreateQuestionRequest = state => {
    return {
        ...state,
        ...{
            createQuestionPending: true,
            createQuestionRes: null,
            createQuestionError: null,
        },
    };
};
const handleCreateQuestionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            createQuestionPending: false,
            createQuestionRes: payload,
            createQuestionError: null,
        },
    };
};
const handleCreateQuestionError = (state, payload) => ({
    ...state,
    ...{
        createQuestionPending: false,
        createQuestionRes: null,
        createQuestionError: payload,
    },
});


/* Get Question Reducers */
const handleGetQuestionRequest = state1 => {
    return {
        ...state1,
        ...{
            getQuestionPending: true,
            getQuestionRes: null,
            getQuestionError: null,
        },
    };
};
const handleGetQuestionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getQuestionPending: false,
            getQuestionRes: payload,
            getQuestionError: null,
        },
    };
};
const handleGetQuestionError = (state1, payload) => ({
    ...state1,
    ...{
        getQuestionPending: false,
        getQuestionRes: null,
        getQuestionError: payload,
    },
});


/* Get Question by Department Reducers */
const handleGetAllQuestionRequest = state1 => {
    return {
        ...state1,
        ...{
            getAllQuestionPending: true,
            getAllQuestionRes: null,
            getAllQuestionError: null,
        },
    };
};
const handleGetAllQuestionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getAllQuestionPending: false,
            getAllQuestionRes: payload,
            getAllQuestionError: null,
        },
    };
};
const handleGetAllQuestionError = (state1, payload) => ({
    ...state1,
    ...{
        getAllQuestionPending: false,
        getAllQuestionRes: null,
        getAllQuestionError: payload,
    },
});

/* Update Question Reducers*/
const handleUpdateQuestionRequest = state1 => {
    return {
        ...state1,
        ...{
            updateQuestionPending: true,
            updateQuestionRes: null,
            updateQuestionError: null,
        },
    };
};
const handleUpdateQuestionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            updateQuestionPending: false,
            updateQuestionRes: payload,
            updateQuestionError: null,
        },
    };
};
const handleUpdateQuestionError = (state1, payload) => ({
    ...state1,
    ...{
        updateQuestionPending: false,
        updateQuestionRes: null,
        updateQuestionError: payload,
    },
});

/* Delete Question Reducers*/
const handleDeleteQuestionRequest = state1 => {
    return {
        ...state1,
        ...{
            deleteQuestionPending: true,
            deleteQuestionRes: null,
            deleteQuestionError: null,
        },
    };
};
const handleDeleteQuestionSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            deleteQuestionPending: false,
            deleteQuestionRes: payload,
            deleteQuestionError: null,
        },
    };
};
const handleDeleteQuestionError = (state1, payload) => ({
    ...state1,
    ...{
        deleteQuestionPending: false,
        deleteQuestionRes: null,
        deleteQuestionError: payload,
    },
});

/* Delete Question Reducers*/
const handleAddAnswerRequest = state1 => {
    return {
        ...state1,
        ...{
            addAnswerPending: true,
            addAnswerRes: null,
            addAnswerError: null,
        },
    };
};
const handleAddAnswerSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            addAnswerPending: false,
            addAnswerRes: payload,
            addAnswerError: null,
        },
    };
};
const handleAddAnswerError = (state1, payload) => ({
    ...state1,
    ...{
        addAnswerPending: false,
        addAnswerRes: null,
        addAnswerError: payload,
    },
});

/* Delete Question Reducers*/
const handleGetDropDownMasterRequest = state1 => {
    return {
        ...state1,
        ...{
            getDropDownMasterPending: true,
            getDropDownMasterRes: null,
            getDropDownMasterError: null,
        },
    };
};
const handleGetDropDownMasterSuccess = (state1, payload) => {
    return {
        ...state1,
        ...{
            getDropDownMasterPending: false,
            getDropDownMasterRes: payload,
            getDropDownMasterError: null,
        },
    };
};
const handleGetDropDownMasterError = (state1, payload) => ({
    ...state1,
    ...{
        getDropDownMasterPending: false,
        getDropDownMasterRes: null,
        getDropDownMasterError: payload,
    },
});



/* Clear Dropdown Store Reducers*/
const handleClearDropdownStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_DROPDOWN_DATA_STORE':
            return {
                ...state,
                ...{
                    addDropdownDataPending: false,
                    addDropdownDataRes: null,
                    addDropdownDataError: null,

                },
            };
        case 'HANDLE_CLEAR_UPDATE_DROPDOWN_DATA_STORE':
            return {
                ...state,
                ...{
                    updateDropdownDataPending: false,
                    updateDropdownDataRes: null,
                    updateDropdownDataError: null,

                },
            };
        case 'HANDLE_CLEAR_DELETE_DROPDOWN_DATA_STORE':
            return {
                ...state,
                ...{
                    deleteDropdownDataPending: false,
                    deleteDropdownDataRes: null,
                    deleteDropdownDataError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_MASTER_DROPDOWN_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    deleteMasterDropdownCategoryPending: false,
                    deleteMasterDropdownCategoryRes: null,
                    deleteMasterDropdownCategoryError: null,
                },
            };
        case 'HANDLE_CLEAR_ADD_MASTER_DROPDOWN_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    addMasterDropdownCategoryPending: false,
                    addMasterDropdownCategoryRes: null,
                    addMasterDropdownCategoryError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_MASTER_DROPDOWN_CATEGORY_STORE':
            return {
                ...state,
                ...{
                    updateMasterDropdownCategoryPending: false,
                    updateMasterDropdownCategoryRes: null,
                    updateMasterDropdownCategoryError: null,
                },
            };
        case 'HANDLE_CLEAR_CREATE_QUESTION_STORE':
            return {
                ...state,
                ...{
                    createQuestionPending: false,
                    createQuestionRes: null,
                    createQuestionError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_QUESTION_STORE':
            return {
                ...state,
                ...{
                    updateQuestionPending: false,
                    updateQuestionRes: null,
                    updateQuestionError: null,
                },
            };
        case 'HANDLE_CLEAR_DELETE_QUESTION_STORE':
            return {
                ...state,
                ...{
                    deleteQuestionPending: false,
                    deleteQuestionRes: null,
                    deleteQuestionError: null,
                },
            };
            case 'HANDLE_CLEAR_ADD_ANSWER_STORE':
            return {
                ...state,
                ...{
                    addAnswerPending: false,
                    addAnswerRes: null,
                    addAnswerError: null,
                },
            };
        default:
            return state;
    }
};


export default createReducer(
    {
        [actions.getFilteredDropdownDataRequest]: handleGetFilteredDropdownDataRequest,
        [actions.getFilteredDropdownDataSuccess]: handleGetFilteredDropdownDataSuccess,
        [actions.getFilteredDropdownDataError]: handleGetFilteredDropdownDataError,

        [actions.addDropdownDataRequest]: handleAddDropdownDataRequest,
        [actions.addDropdownDataSuccess]: handleAddDropdownDataSuccess,
        [actions.addDropdownDataError]: handleAddDropdownDataError,

        [actions.getAllDropdownDataRequest]: handleGetAllDropdownDataRequest,
        [actions.getAllDropdownDataSuccess]: handleGetAllDropdownDataSuccess,
        [actions.getAllDropdownDataError]: handleGetAllDropdownDataError,

        [actions.deleteDropdownDataRequest]: handleDeleteDropdownDataRequest,
        [actions.deleteDropdownDataSuccess]: handleDeleteDropdownDataSuccess,
        [actions.deleteDropdownDataError]: handleDeleteDropdownDataError,

        [actions.updateDropdownDataRequest]: handleUpdateDropdownDataRequest,
        [actions.updateDropdownDataSuccess]: handleUpdateDropdownDataSuccess,
        [actions.updateDropdownDataError]: handleUpdateDropdownDataError,

        [actions.getDropdownMasterConstantDataRequest]: handleGetDropdownMasterConstantDataRequest,
        [actions.getDropdownMasterConstantDataSuccess]: handleGetDropdownMasterConstantDataSuccess,
        [actions.getDropdownMasterConstantDataError]: handleGetDropdownMasterConstantDataError,

        [actions.addMasterDropdownCategoryRequest]: handleAddMasterDropdownCategoryRequest,
        [actions.addMasterDropdownCategorySuccess]: handleAddMasterDropdownCategorySuccess,
        [actions.addMasterDropdownCategoryError]: handleAddMasterDropdownCategoryError,

        [actions.updateMasterDropdownCategoryRequest]: handleUpdateMasterDropdownCategoryRequest,
        [actions.updateMasterDropdownCategorySuccess]: handleUpdateMasterDropdownCategorySuccess,
        [actions.updateMasterDropdownCategoryError]: handleUpdateMasterDropdownCategoryError,

        [actions.getMasterDropdownCategoryRequest]: handleGetMasterDropdownCategoryRequest,
        [actions.getMasterDropdownCategorySuccess]: handleGetMasterDropdownCategorySuccess,
        [actions.getMasterDropdownCategoryError]: handleGetMasterDropdownCategoryError,

        [actions.getAllMasterDropdownCategoryRequest]: handleGetAllMasterDropdownCategoryRequest,
        [actions.getAllMasterDropdownCategorySuccess]: handleGetAllMasterDropdownCategorySuccess,
        [actions.getAllMasterDropdownCategoryError]: handleGetAllMasterDropdownCategoryError,

        [actions.deleteMasterDropdownCategoryRequest]: handleDeleteMasterDropdownCategoryRequest,
        [actions.deleteMasterDropdownCategorySuccess]: handleDeleteMasterDropdownCategorySuccess,
        [actions.deleteMasterDropdownCategoryError]: handleDeleteMasterDropdownCategoryError,

        [actions.createQuestionRequest]: handleCreateQuestionRequest,
        [actions.createQuestionSuccess]: handleCreateQuestionSuccess,
        [actions.createQuestionError]: handleCreateQuestionError,

        [actions.getQuestionRequest]: handleGetQuestionRequest,
        [actions.getQuestionSuccess]: handleGetQuestionSuccess,
        [actions.getQuestionError]: handleGetQuestionError,

        [actions.getAllQuestionRequest]: handleGetAllQuestionRequest,
        [actions.getAllQuestionSuccess]: handleGetAllQuestionSuccess,
        [actions.getAllQuestionError]: handleGetAllQuestionError,

        [actions.updateQuestionRequest]: handleUpdateQuestionRequest,
        [actions.updateQuestionSuccess]: handleUpdateQuestionSuccess,
        [actions.updateQuestionError]: handleUpdateQuestionError,

        [actions.deleteQuestionRequest]: handleDeleteQuestionRequest,
        [actions.deleteQuestionSuccess]: handleDeleteQuestionSuccess,
        [actions.deleteQuestionError]: handleDeleteQuestionError,

        [actions.addAnswerRequest]: handleAddAnswerRequest,
        [actions.addAnswerSuccess]: handleAddAnswerSuccess,
        [actions.addAnswerError]: handleAddAnswerError,

        [actions.getDropDownMasterRequest]: handleGetDropDownMasterRequest,
        [actions.getDropDownMasterSuccess]: handleGetDropDownMasterSuccess,
        [actions.getDropDownMasterError]: handleGetDropDownMasterError,

        [actions.handleClearDropdownStore]: handleClearDropdownStore
    },
    initialState,
);